interface ContactFieldProps {
  label: string;
  type?: "text" | "email" | "textarea";
  value: string;
  onChange: (value: string) => void;
  maxLength?: number;
  charCount?: number;
}

export function ContactField({
  label,
  type = "text",
  value,
  onChange,
  maxLength,
  charCount,
}: ContactFieldProps) {
  return (
    <div className="form-item">
      <label className="form-label">{label}</label>
      {type === "textarea" ? (
        <>
          <textarea
            className="form-textarea form-input-message"
            rows={3}
            maxLength={maxLength}
            value={value}
            onChange={(e) => onChange(e.target.value)}
          />
          {maxLength !== undefined && (
            <label className="form-textarea-chars">
              {charCount ?? 0}/{maxLength}
            </label>
          )}
        </>
      ) : (
        <input
          type={type}
          className="form-textbox"
          value={value}
          onChange={(e) => onChange(e.target.value)}
        />
      )}
    </div>
  );
}
